module.exports = __webpack_public_path__ + "media/vox.22db316e.mp4";